var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxesIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 180,
  height: 139,
  viewBox: "0 0 180 139",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M168.111 78.5866L97.4084 117.988L11 70.7336L81.7023 39.4141L168.111 78.5866Z",
  fill: "#E2EDFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M97.4084 124.364L11 77.1158V70.7344L97.4084 117.989V124.364Z",
  fill: "#60A2F0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M97.4082 117.987L168.11 78.5859V84.9673L97.4082 124.362V117.987Z",
  fill: "#9FC2ED"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.4 24.4313L102.61 22.2601L90.7416 15.5L60.3223 32.8691L72.1409 39.6292L75.9309 41.8004L88.9963 49.2513L119.366 31.8822L106.4 24.4313Z",
  fill: "#CDE1F9"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M90.7413 16.0938L61.3691 32.8707L88.9959 48.4634L118.318 31.8345L90.7413 16.0938Z",
  fill: "#E2EDFF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M88.9963 49.2494L88.9964 73.9652L75.8811 66.5636L72.0413 64.4418L60.3224 57.7803L60.3223 32.8672L88.9963 49.2494Z",
  fill: "#9FC2ED"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M88.9972 49.2519L88.9473 74.1143L119.416 56.8932L119.417 31.8828L88.9972 49.2519Z",
  fill: "#B8D0F2"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M75.8808 41.8484L75.8808 66.7222L72.041 64.6004L72.041 39.7266L75.8808 41.8484Z",
  fill: "#CF4F86"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M106.4 24.4329L95.7282 30.5022L91.9383 32.7227L75.9806 41.802L75.831 41.9006L72.041 39.7295L72.1408 39.6308L88.1483 30.5022L91.9383 28.331L102.61 22.2617L106.4 24.4329Z",
  fill: "#FF8BBD"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M137.959 50.0836L134.169 47.9125L122.3 41.1523L91.8809 58.5214L103.7 65.2816L107.489 67.4527L120.555 74.9037L150.924 57.5346L137.959 50.0836Z",
  fill: "#CDE1F9"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M122.3 41.7422L92.9277 58.5192L120.555 74.1119L149.877 57.4829L122.3 41.7422Z",
  fill: "#E2EDFF"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M120.555 74.9017L120.555 92.8912L107.44 85.4896L103.6 83.3678L91.881 76.7064L91.8809 58.5195L120.555 74.9017Z",
  fill: "#9FC2ED"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M120.556 74.9042L120.506 93.0403L150.975 75.8192L150.975 57.5352L120.556 74.9042Z",
  fill: "#B8D0F2"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M107.439 67.5007L107.439 85.6482L103.6 83.5264L103.6 65.3789L107.439 67.5007Z",
  fill: "#CF4F86"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M137.959 50.0813L127.287 56.1506L123.497 58.3711L107.539 67.4504L107.39 67.5491L103.6 65.3779L103.699 65.2793L119.707 56.1506L123.497 53.9795L134.169 47.9102L137.959 50.0813Z",
  fill: "#FF8BBD"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M75.9314 29.3844L72.1414 27.2133L60.2729 20.4531L29.8535 37.8222L41.6722 44.5824L45.4621 46.7535L58.5275 54.2044L88.897 36.8353L75.9314 29.3844Z",
  fill: "#CDE1F9"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2725 21.0469L30.9004 37.8238L58.5272 53.4166L87.8494 36.7876L60.2725 21.0469Z",
  fill: "#E2EDFF"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5275 54.2025V92.8882L45.4123 85.4866L41.5725 83.3648L29.8535 76.7034V37.8203L58.5275 54.2025Z",
  fill: "#9FC2ED"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M58.5284 54.205L58.4785 92.8907L88.9477 75.6697V36.8359L58.5284 54.205Z",
  fill: "#B8D0F2"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M45.4121 46.8015V85.4872L41.5723 83.3654V44.6797L45.4121 46.8015Z",
  fill: "#CF4F86"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M75.9312 29.386L65.2595 35.4553L61.4695 37.6758L45.5118 46.7551L45.3622 46.8538L41.5723 44.6826L41.672 44.5839L57.6796 35.4553L61.4695 33.2842L72.1412 27.2148L75.9312 29.386Z",
  fill: "#FF65A7"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M65.9519 64.2989L65.4512 64.5962V57.1645L65.9519 56.8672V64.2989Z",
  fill: "#424078"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M67.4542 57.6578L67.1538 58.1533L65.7518 57.1624L64.2496 59.8378L63.9492 59.6396L65.7518 56.4688L67.4542 57.6578Z",
  fill: "#424078"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M70.258 61.8184L69.8574 62.1157V54.684L70.258 54.3867V61.8184Z",
  fill: "#424078"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M71.7608 55.1813L71.4604 55.6767L70.0584 54.6858L68.5563 57.3612L68.2559 57.1631L70.0584 53.9922L71.7608 55.1813Z",
  fill: "#424078"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8606 61.1302L63.7491 65.7875C63.649 65.8865 63.5488 65.7875 63.5488 65.6884C63.5488 65.5893 63.649 65.3911 63.7491 65.292L71.8606 60.6348C71.9607 60.5357 72.0609 60.6348 72.0609 60.7339C72.161 60.9321 72.0609 61.1302 71.8606 61.1302Z",
  fill: "#424078"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M71.8606 63.2103L63.9494 67.7684C63.1483 68.2639 62.4473 67.8675 62.4473 66.8766V57.8595C62.4473 56.8686 63.1483 55.7786 63.9494 55.2831L71.8606 50.725C72.6617 50.2296 73.3627 50.6259 73.3627 51.6168V60.634C73.3627 61.5258 72.6617 62.7149 71.8606 63.2103ZM63.9494 55.6795C63.3485 55.9768 62.8478 56.8686 62.8478 57.5622V66.5794C62.8478 67.273 63.3485 67.5703 63.9494 67.1739L71.8606 62.6158C72.4614 62.3185 72.9621 61.4267 72.9621 60.7331V51.7159C72.9621 51.0223 72.4614 50.725 71.8606 51.1214L63.9494 55.6795Z",
  fill: "#424078"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M79.4698 57.4617C79.3697 57.5608 79.2695 57.4617 79.2695 57.3626V50.9218C79.2695 50.8227 79.3697 50.6245 79.4698 50.5254C79.57 50.4263 79.6701 50.5254 79.6701 50.6245V57.0653C79.6701 57.1644 79.57 57.3626 79.4698 57.4617Z",
  fill: "#424078"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M83.4758 56.3705L75.5646 60.9286C74.7635 61.4241 74.0625 61.0277 74.0625 60.0368V51.0196C74.0625 50.0287 74.7635 48.9387 75.5646 48.4433L83.4758 43.8852C84.2769 43.3897 84.9779 43.7861 84.9779 44.777V53.7941C84.9779 54.785 84.2769 55.875 83.4758 56.3705ZM75.4645 48.8397C74.8636 49.1369 74.3629 50.0287 74.3629 50.7224V59.7395C74.3629 60.4332 74.8636 60.7304 75.4645 60.3341L83.3757 55.7759C83.9765 55.4787 84.4772 54.5869 84.4772 53.8932V44.8761C84.4772 44.1824 83.9765 43.8852 83.3757 44.2815L75.4645 48.8397Z",
  fill: "#424078"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M82.7753 50.9217C82.4749 49.7326 81.0729 49.4353 79.4707 50.3271C77.8684 51.2189 76.4664 53.1016 76.166 54.588L82.7753 50.9217Z",
  fill: "#424078"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M78.3683 50.1297C78.2681 50.2288 78.168 50.1297 78.168 50.0306V48.4452C78.168 48.3461 78.2681 48.1479 78.3683 48.0489C78.4684 47.9498 78.5685 48.0489 78.5685 48.1479V49.7334C78.5685 49.9316 78.4684 50.1297 78.3683 50.1297Z",
  fill: "#424078"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M79.4698 49.5321C79.3697 49.6312 79.2695 49.5321 79.2695 49.433V47.8476C79.2695 47.7485 79.3697 47.5503 79.4698 47.4512C79.57 47.3521 79.6701 47.4512 79.6701 47.5503V49.1357C79.6701 49.2348 79.57 49.433 79.4698 49.5321Z",
  fill: "#424078"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M80.5714 48.8407C80.4712 48.9398 80.3711 48.8407 80.3711 48.7416V47.1562C80.3711 47.0571 80.4712 46.8589 80.5714 46.7598C80.6715 46.6607 80.7717 46.7598 80.7717 46.8589V48.4443C80.8718 48.6425 80.7717 48.8407 80.5714 48.8407Z",
  fill: "#424078"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M91.8257 62.4609L77.9531 70.6161L90.7055 77.9119L104.532 69.7567L91.8257 62.4609Z",
  fill: "#FF8BBD"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M91.9765 63.1445L78.9277 70.6155L90.3806 77.0757L103.093 69.6643L91.9765 63.1445Z",
  fill: "#FFA2CA"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M90.6361 77.7643V94.7103L77.9532 87.5293L77.9531 70.6172L90.6361 77.7643Z",
  fill: "#CF4F86"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M90.6362 77.8536L90.5898 94.7184L104.543 86.4514V69.7188L90.6362 77.8536Z",
  fill: "#F477AD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boxes-icon.5582ec1b8e32c7709fcd95b60e7078c5.svg";